import React from "react";
import Header from "../Header";
import MainComponent from "../MainComponent";
import Footer from "../Footer";
import FooterDown from "../FooterDown";
import TermsOfUse from "./TermsOfUse";

const TermsOfUsePage = () => {
  return (
    <div>
      <Header />
      <MainComponent type="terms" />
      <TermsOfUse />
      <Footer />
      <FooterDown />
    </div>
  );
};

export default TermsOfUsePage;
